import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppDispatch } from '../hooks';
import { addPrivateSystemMessage } from '../slices/chatSlice';

export function useFightActionError() {
  const dispatch = useAppDispatch();
  const [error, setError] = useState('');
  const timer = useRef<number>();
  const clear = useCallback(() => {
    window.clearTimeout(timer.current);
    setError('');
  }, []);
  useEffect(() => () => window.clearTimeout(timer.current), []);

  const show = (action: 'Skip' | 'Rebirth', message: string) => {
    window.clearTimeout(timer.current);
    if (/not enough coupons|คูปองไม่พอ/i.test(message)) {
      setError('ทำรายการไม่สำเร็จ! คูปองไม่พอ');
      timer.current = window.setTimeout(() => setError(''), 3000);
      dispatch(addPrivateSystemMessage({
        kind: 'system', localNotice: 'error', user: 'System', id: 0, serverId: 0,
        message: `ทำรายการ ${action} ไม่สำเร็จ! คูปองไม่พอ`,
      }));
    } else setError(message);
  };
  return { error, show, clear };
}
